"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.101 8.033C.101 3.668 3.652.117 8.017.117s7.916 3.551 7.916 7.916-3.55 7.916-7.916 7.916C3.652 15.95.101 12.4.101 8.033Zm14.832 0a6.877 6.877 0 0 1-1.728 4.557L3.46 2.845a6.875 6.875 0 0 1 4.557-1.728 6.924 6.924 0 0 1 6.916 6.916Zm-13.832 0c0-1.708.625-3.27 1.655-4.478l9.74 9.74a6.884 6.884 0 0 1-4.479 1.654 6.924 6.924 0 0 1-6.916-6.916Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.07 11.956C.07 5.381 5.42.031 11.993.031c6.576 0 11.926 5.35 11.926 11.925 0 6.576-5.35 11.925-11.926 11.925C5.42 23.881.07 18.532.07 11.956Zm22.725 0c0 2.805-1.084 5.356-2.844 7.278L4.717 4a10.742 10.742 0 0 1 7.277-2.844c5.956 0 10.801 4.845 10.801 10.8Zm-21.6 0c0-2.746 1.038-5.248 2.732-7.156L19.15 20.024a10.74 10.74 0 0 1-7.156 2.732c-5.955 0-10.8-4.845-10.8-10.8Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.092 15.941c0-8.767 7.133-15.9 15.9-15.9 8.768 0 15.901 7.133 15.901 15.9 0 8.768-7.133 15.9-15.9 15.9-8.768 0-15.9-7.132-15.9-15.9Zm30.301 0c0 3.74-1.446 7.141-3.792 9.704L6.29 5.333c2.563-2.347 5.963-3.792 9.703-3.792 7.941 0 14.401 6.46 14.401 14.4Zm-28.8 0c0-3.66 1.384-6.997 3.643-9.54l20.297 20.297c-2.543 2.26-5.879 3.643-9.54 3.643-7.94 0-14.4-6.46-14.4-14.4Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M47.916 24.018c0 6.294-2.458 12.024-6.458 16.289l.005.005-.183.181c-.237.247-.479.49-.727.727l-.416.417-.01-.01a23.746 23.746 0 0 1-16.05 6.229C10.932 47.856.239 37.162.239 24.018.239 10.873 10.932.179 24.077.179c13.144 0 23.838 10.694 23.838 23.839Zm-1.875 0c0 5.778-2.247 11.039-5.908 14.964L9.112 7.962c3.925-3.661 9.186-5.908 14.965-5.908 12.11 0 21.963 9.853 21.963 21.964ZM24.077 45.98c-12.11 0-21.963-9.853-21.963-21.963 0-5.66 2.151-10.825 5.68-14.724L38.8 40.3a21.878 21.878 0 0 1-14.723 5.68Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M63.887 32.024c0 8.393-3.277 16.032-8.61 21.719l.006.006-.243.242c-.316.33-.639.653-.969.97l-.556.555-.013-.013c-5.652 5.156-13.165 8.305-21.4 8.305C14.576 63.808.318 49.55.318 32.024S14.576.239 32.102.239s31.785 14.259 31.785 31.785Zm-2.5 0c0 7.704-2.996 14.719-7.877 19.952l-41.36-41.36c5.233-4.881 12.247-7.877 19.952-7.877 16.147 0 29.285 13.137 29.285 29.285ZM32.102 61.308c-16.147 0-29.284-13.137-29.284-29.284 0-7.546 2.87-14.433 7.574-19.631l41.341 41.34c-5.198 4.705-12.085 7.575-19.63 7.575Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconDecline = function IconDecline(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Decline' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Decline"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconDecline.sizes = [16, 24, 32, 48, 64];
IconDecline.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconDecline;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/system/Decline.js
// module id = 2361
// module chunks = 0